import { stringToDate } from './stringToDate';
import { isValidDate } from './utils';
export const getOptionByText = (options, text) => {
    if (typeof text !== 'string')
        return null;
    if (isValidDate(stringToDate(text)))
        return options.find((o) => o.text === text);
    return null;
};
//# sourceMappingURL=getOptionByText.js.map